import { useMutation } from '@tanstack/react-query'

import api from '@/lib/api'
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'

export interface CreatePrevidenciarioRequest {
  id_apuracao_competencia: string
}

export interface CreatePrevidenciarioResponse {
  id: string
  id_apuracao_competencia: string
  [key: string]: unknown
}

export function useCreatePrevidenciario() {
  const token = useAccessToken()
  const user = useCurrentUser()

  return useMutation({
    mutationFn: async (payload: CreatePrevidenciarioRequest): Promise<CreatePrevidenciarioResponse> => {
      if (!payload.id_apuracao_competencia?.trim()) {
        throw new Error('id_apuracao_competencia é obrigatório')
      }

      if (!user || !token) {
        throw new Error('Usuário não autenticado')
      }

      const response = await api.post<CreatePrevidenciarioResponse>('/previdenciario/criar', payload, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (!response.data?.id) {
        throw new Error('Erro ao criar previdenciário')
      }

      return response.data
    }
  })
}
